import brickTypes from './brick-types';
import getResource from "../../../Util/resources";
import displayFormats from './brick-display-formats';
import ENDPOINT_TYPES from '@core/Components/DragAndDrop/endpoint-types';

const commentSupportingBrickTypes = [
    brickTypes.abTest,
    brickTypes.touchpoint,
    brickTypes.audienceFilter,
    brickTypes.goal
];

/**
 * Create a new brick definition
 * @param {string} name
 * @param {number} type
 * @param {string} displayNameResource
 * @param {string} icon
 * @param {string} displayFormat
 * @param {Object} [connectionOptions]
 * @param {number} [connectionOptions.maxIncomingConnections=Infinity]
 * @param {string} [connectionOptions.unconnectedIncomingEndpointType=Blank]
 * @return {{supportsComments: boolean, readonly displayName: string, name: string, icon: string, displayFormat: string, type: number, connectionOptions: *}|*}
 */
const createBrickDefinition = (
    name, 
    type, 
    displayNameResource, 
    icon, 
    displayFormat,
    connectionOptions
) => {
    connectionOptions = connectionOptions || {};
    connectionOptions = {
        maxIncomingConnections: Infinity,
        unconnectedIncomingEndpointType: ENDPOINT_TYPES.BLANK,
        ...connectionOptions
    };
    
    return {
        name: name,
        type: type,
        icon: icon,
        displayFormat: displayFormat,
        supportsComments: commentSupportingBrickTypes.includes(type),
        connectionOptions: connectionOptions,
        get displayName() { 
            //Resources are not expected to be available on import
            return getResource(displayNameResource);
        }
    };
};

const brickDefinitions = {
    [brickTypes.audience]: createBrickDefinition(
        'audience',
        brickTypes.audience,
        'JourneyComposerBrickType_Audience_DisplayName',
        'fas fa-user-friends',
        displayFormats.square
    ),
    [brickTypes.journey]: createBrickDefinition(
        'journey',
        brickTypes.journey,
        'JourneyComposerBrickType_Journey_DisplayName',
        'fas fa-route',
        displayFormats.square
    ),
    [brickTypes.touchpoint]: createBrickDefinition(
        'touchpoint',
        brickTypes.touchpoint,
        'JourneyComposerBrickType_Touchpoint_DisplayName',
        'fas fa-hand-point-right',
        displayFormats.square
    ),
    [brickTypes.audienceFilter]: createBrickDefinition(
        'audienceFilter',
        brickTypes.audienceFilter,
        'JourneyComposerBrickType_AudienceFilter_DisplayName',
        'fas fa-map-signs',
        displayFormats.octagon
    ),
    [brickTypes.abTest]: createBrickDefinition(
        'abTest',
        brickTypes.abTest,
        'JourneyComposerBrickType_ABTest_DisplayName',
        'fas fa-spell-check',
        displayFormats.octagon
    ),
    [brickTypes.goal]: createBrickDefinition(
        'goal',
        brickTypes.goal,
        'JourneyComposerBrickType_Goal_DisplayName',
        'fas fa-check-circle',
        displayFormats.square,
        {
            //https://datanext.atlassian.net/browse/DPN-3125
            //Goal bricks are allowed to have more than 1 connection
            
            //Goal bricks may only have a single incoming/outgoing connection
            // maxIncomingConnections: 1,
            
            // unconnectedIncomingEndpointType: ENDPOINT_TYPES.DOT
        }
    )
};

const brickDefinitionsArray = Object.values(brickDefinitions);

export {
    brickDefinitions,
    brickDefinitionsArray
};
